// src/Policy.js
import React from 'react';
import './Policy.css';

function Policy({ title, icon, children }) {
  return (
    <div className="Policy">
      <h1>{title}</h1>
      
      {/* Icon Section */}
      <div className="policy-icon-container">
        <img src={icon} alt={`${title} Icon`} className="policy-icon" />
      </div>
      
      {/* Policy Body */}
      <p>{children}</p>
    </div>
  );
}

export default Policy;
